/**
 *
 * @page 用户中心/我的方案/项目管理/方案详情 （协作）
 *
 **/
import React from 'react';
import {
    Tabs,
    Empty,
    Modal,
    Form,
    Select,
    Checkbox,
    message,
    Button,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { createPortal } from 'react-dom';

import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import SynergyTurbineTab from '&/components/ProjectSpace/SynergyTurbineTab';
// import ChangeHistoryTab from '@/components/UserCenter/ChangeHistoryTab';
import ProjectInfoTab from '&/components/ProjectSpace/ProjectInfoTab';
import ConstructionDrawing from '&/components/ConstructionDrawing/Project';
import ScheduleProgressTab from '&/components/ProjectSpace/PlansProgress';
import ProjectPaymentTab from '&/components/ProjectSpace/ProjectPaymentTab';
import { useHistory, useLocation } from 'react-router-dom';
import { SYNERGIA_TAB_STATUS } from '&/utils/baseMacro';
import { queryProductContent } from '&/api/personCenter/projectSpace';
import { useStoreState } from '&/utils/customHooks';
import { getRoleList } from '&/api/personCenter/teamManage';
import { tipJoinProject } from '@/api/personCenter/projectSpace';
import usePermission from '&/utils/customHooks/usePermission';

import './SchemeDetail.scss';

const { DRAWING, PLANS, INFO, MEMBERS, PAYMENT /* LOGS, BUDGET */ } =
    SYNERGIA_TAB_STATUS;

const ProjectDetail = props => {
    const { setBreadcrumb } = props;
    const location = useLocation();
    const history = useHistory();
    const [projectInfo, setProjectInfo] = useState({ houseType: [] });
    const [genreList, setGenreList] = useState([]);
    const SEARCH = new URLSearchParams(location.search);
    const projectId = SEARCH.get('id');
    const [payStatus, setPayStatus] = useState(location.state?.projectStatus);
    const [errorType, setErrorType] = useState(false);
    const [activeTab, setActiveTab] = useState({});
    const [tabs, setTabs] = useState([]);
    const [showAddMember, setShowAddMember] = useState(false);
    const TAB_NAME = SEARCH.get('tab');
    const { organization } = useStoreState('appStore');
    const [isShowTip, setIsShowTip] = useState(false);
    const [isProjectDefaultRole, setIsProjectDefaultRole] = useState(false);
    const [, , , refreshPermissions] = usePermission(projectId);

    const showJoinTip = location.state?.showJoinTip;

    useEffect(() => {
        refreshPermissions();
        window.addEventListener('target_project_list', targetListPage);
        queryRoleList();
        return () => {
            window.removeEventListener('target_project_list', targetListPage);
        };
    }, []);

    function targetListPage() {
        history.push('/user-center/project-space');
    }

    const [showPay, setShowPay] = useState(false);

    const toPay = () => {
        setShowPay(true);
        onChange(INFO);
    };

    const TABS = [
        {
            name: '施工图',
            key: DRAWING,
        },
        {
            name: intl.get('projectSpace.scheduleProgress'),
            key: PLANS,
        },
        {
            name: '项目款项',
            key: PAYMENT,
        },
        {
            name: intl.get('projectSpace.projectInfo'),
            key: INFO,
        },
        // {
        //     name: intl.get('projectSpace.changeHistory'),
        //     key: LOGS,
        // },
        {
            name: intl.get('projectSpace.projectTurbine'),
            key: MEMBERS,
        },
        // {
        //     name: intl.get('projectSpace.budgetList'),
        //     key: BUDGET,
        // },
    ];
    const COMPONENTS = {
        [DRAWING]: <ConstructionDrawing info={projectInfo} />,
        [PLANS]: <ScheduleProgressTab payStatus={payStatus} />,
        [PAYMENT]: <ProjectPaymentTab />,
        [INFO]: (
            <ProjectInfoTab
                div="2"
                info={projectInfo}
                projectId={projectId}
                genreList={genreList}
                queryInfo={queryDetail}
                showPay={showPay}
                displayedCb={() => setShowPay(false)}
            />
        ),
        [MEMBERS]: (
            <SynergyTurbineTab
                showAddMember={showAddMember}
                setShowAddMember={setShowAddMember}
            />
        ),
    };

    useEffect(() => {
        queryDetail();

        return () => {
            // 清空面包屑
            setBreadcrumb('');
        };
    }, []);

    useEffect(() => {
        onStatusChange();
    }, [payStatus]);

    useEffect(() => {
        TAB_NAME && onChange(TAB_NAME);
    }, [TAB_NAME]);

    async function queryDetail() {
        try {
            const { data } = await queryProductContent(
                { projectId },
                10001,
                'ProjectDetail'
            );
            setGenreList(data.genre);
            data.detail.houseType = data.detail.houseType?.map(e => +e);
            setProjectInfo(data.detail);
            setBreadcrumb(data.detail.name);
            setPayStatus(data.detail.status);
            setIsProjectDefaultRole(data.isProjectDefaultRole);
            if (+data.detail.status === 3) {
                setIsShowTip(false);
                return;
            }
            tipJoinProject({ div: 1, projectId }).then(({ data }) => {
                // 判断是否显示 提示添加项目成员的接口
                let isEmpty = Array.isArray(data) && data.length === 0;
                let isDefault = +data?.isDefault === 2;
                let deleteRole = +data?.isDefault === 1 && !data?.roleId;
                setIsShowTip(isEmpty || isDefault || deleteRole);
            });
        } catch ({ code }) {
            code === 10001 && setErrorType(true);
        }
    }

    function onStatusChange() {
        // if (status < 0) history.push('/user-center/project-space');
        if (!payStatus) return;
        //   项目正常使用或者快到期  给显示全部的tab  否则只显示项目信息
        if (['1', '4', '5'].includes(payStatus)) {
            setTabs(TABS);
            onChange(TAB_NAME || DRAWING);
        } else {
            // 3 表示待支付
            onChange(INFO);
            setTabs([TABS[3]]);
        }
    }

    const onChange = key => {
        setActiveTab(TABS.find(el => el.key === key));

        if (TAB_NAME && TAB_NAME !== key) {
            location.search = '?id=' + SEARCH.get('id');
            history.replace(location.search);
        }
    };

    function targetPage(page) {
        const links = {
            home: '/home',
            resource: '/model-base/model-base-home',
            houseType: '/house-type/home',
        };
        history.push(links[page]);
    }

    const { TabPane } = Tabs;
    const EMPTY = (
        <div className="empty-project">
            <Empty
                image={require('&/assets/img/userCenter/jiesan.png').default}
                imageStyle={{
                    height: 191,
                }}
                description={
                    <>
                        <div className="result-message">项目已被创建人解散</div>
                        <div className="marketing-title">您也可以</div>
                        <div className="marketing-item">
                            1、访问福昕.家装
                            <span
                                className="native-link"
                                onClick={() => targetPage('home')}>
                                首页
                            </span>
                        </div>
                        <div className="marketing-item">
                            2、去其他地方逛逛{' '}
                            <span
                                className="native-link"
                                onClick={() => targetPage('resource')}>
                                资源库
                            </span>
                            、
                            <span
                                className="native-link"
                                onClick={() => targetPage('houseType')}>
                                户型库
                            </span>
                        </div>
                    </>
                }></Empty>
        </div>
    );
    const showAddToProjectTip = useRef(true);
    const confirm = () => {
        if (showAddToProjectTip.current) {
            Modal.confirm({
                title: '是否加入该项目？',
                icon: <ExclamationCircleOutlined />,
                content: '没有项目成员会影响功能的使用，请选择您是否加入项目',
                okText: '加入项目',
                cancelText: '添加成员',
                closable: true,
                className: 'join-project-confirm',
                cancelButtonProps: { type: 'link' },
                onCancel: e => {
                    onChange(MEMBERS);
                    if (!e.triggerCancel) {
                        setShowAddMember(true);
                        e();
                    }
                },
                onOk: e => {
                    showModal();
                    e();
                },
            });
            showAddToProjectTip.current = false;
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        formRef.submit();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        onChange(MEMBERS);
    };

    const [formRef] = Form.useForm();

    const onSubmitName = values => {
        tipJoinProject({
            div: 2,
            roleId: values.role,
            isDefault: values.remember ? 1 : 2,
            projectId,
        }).then(() => {
            refreshPermissions();
            setIsModalOpen(false);
            onChange(MEMBERS);
        });
    };

    const [roleList, setRoleList] = useState([]);
    const info = organization || {};

    const queryRoleList = () => {
        const { enterpriseId, branchId } = info;
        const entId = branchId || enterpriseId;
        if (roleList.length) return;
        getRoleList({ entId }, entId)
            .then(({ data }) => {
                const LIST = data
                    .filter(el => !!el.isBan)
                    .map(e => ({
                        powerId: e.powerId ? JSON.parse(e.powerId || null) : [],
                        label: e.roleName,
                        value: e.roleId,
                    }));
                setRoleList(LIST);
            })
            .catch(err => {
                if (err.isUnSelect) return message.warn('请选择企业');
            });
    };

    const alertEl = React.useMemo(() => {
        console.log(typeof payStatus);
        return (
            payStatus === '4' &&
            document.getElementById('custom-alert-wrap') &&
            createPortal(
                <div className="past-due-alert">
                    <i className="filled icon-info-circle2-copy"></i>
                    项目已过期，请续费后使用
                    <Button type="primary" onClick={toPay}>
                        续费使用
                    </Button>
                </div>,
                document.getElementById('custom-alert-wrap')
            )
        );
    }, [payStatus, document.getElementById('custom-alert-wrap')]);

    return errorType ? (
        EMPTY
    ) : (
        <>
            {alertEl}
            {showJoinTip && isProjectDefaultRole && isShowTip && confirm()}
            <Modal
                width={400}
                maskClosable={false}
                title="加入项目"
                wrapClassName="join-project-modal"
                visible={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}>
                <Form
                    labelCol={{ span: 7 }}
                    form={formRef}
                    onFinish={onSubmitName}>
                    <Form.Item
                        name="role"
                        validateFirst
                        label="选择角色"
                        rules={[
                            {
                                required: true,
                                message: '请选择角色',
                            },
                        ]}>
                        <Select allowClear options={roleList}></Select>
                    </Form.Item>
                    <Form.Item
                        colon={false}
                        name="remember"
                        label=" "
                        valuePropName="checked">
                        <Checkbox>始终以该角色加入项目</Checkbox>
                    </Form.Item>
                </Form>
            </Modal>
            <BasePageWrap
                className={
                    activeTab.key === DRAWING
                        ? 'project-detail-con-draw project-detail'
                        : 'project-detail'
                }
                header={
                    <Tabs
                        activeKey={activeTab.key}
                        onChange={onChange}
                        className="use-antd"
                        renderTabBar={(props, DefaultTabBar) => (
                            <DefaultTabBar
                                {...props}
                                className="use-antd-tab"
                            />
                        )}>
                        {tabs.map(({ name, key }) => (
                            <TabPane tab={name} key={key}></TabPane>
                        ))}
                    </Tabs>
                }
                type={'card'}>
                {COMPONENTS[activeTab.key]}
            </BasePageWrap>
        </>
    );
};

export default ProjectDetail;
